import Register from "pages/Register";

export default function RegisterPage() {
  return <Register />;
}
